import _ from 'lodash';
import { request } from '../functions';
import { CLEAN_APPS, FETCH_APPS } from './types';
import { COOKIE_SETTINGS, COOKIE_APPS_NAME } from '../config';

/**
 * Nacitanie dashboardu.
 *
 * @param {Screen} screen
 * @param {string} date
 */
export const fetchApps = (screen) => {
    const { cookies } = screen.props;

    let params = {};

    return dispatch => request('/user-eshops/apps', params).then(({ data }) => {
        const { user } = data.sync;
        const { setUser } = screen.props;

        // Nasetujeme usera
        setUser(user);

        if (!_.isEmpty(user) && _.has(user, 'apps')) {
            // Nastavime
            cookies.set(COOKIE_APPS_NAME, user.apps.toString(), COOKIE_SETTINGS);
        }

        dispatch({ type: FETCH_APPS, payload: data.data });
    });
};

export const cleanApps = () => ({ type: CLEAN_APPS });
